<template>
	<div class="inline-block">
		<i v-if="type === 'Employee'" class="nucleo nucleo-single-01-2 mr-1"></i>
		<i v-if="type === 'Department'" class="nucleo nucleo-multiple-11-2 mr-1"></i>
		<i v-if="type === 'Title'" class="nucleo nucleo-badge-14 mr-1"></i>
		<i v-if="type === 'Device'" class="nucleo nucleo-server-2 mr-1"></i>
		<i v-if="type === 'Todolist'" class="nucleo nucleo-archive-paper-2 mr-1"></i>
		<i v-if="type === 'RequestV2'" class="nucleo nucleo-file-paragraph mr-1"></i>
	</div>
</template>

<script>
export default {
	name: "CbsRelationIcon",
	props: {
		type: String
	}
};
</script>
